import Typography from '@/components/next-ui/Typography';
import { Listbox, Transition } from '@headlessui/react';
import { cx } from 'cva';
import { isEmpty } from 'lodash-es';
import { CheckIcon } from 'lucide-react';
import React, { Fragment } from 'react';
import { HiChevronDown } from 'react-icons/hi';

function ProjectSelector(props) {
  const { value, onChange, projects, required, error } = props;
  let displayValue = 'Select Project';
  if (value) {
    displayValue = value.name;
  } else if (projects.length === 0) {
    displayValue = 'No projects available';
  }

  return (
    <div>
      <div className="flex items-center justify-start gap-0.5">
        <Typography variant="h5" className="uppercase" component="label">
          Project
        </Typography>
        {required && (
          <Typography variant="h5" component="span" color="error">
            *
          </Typography>
        )}
      </div>
      <Listbox
        value={value}
        onChange={onChange}
        disabled={isEmpty(projects)}
        by="id">
        <div className="relative mt-1 w-full">
          <Listbox.Button className="focus:shadow-outline relative flex w-full cursor-pointer items-center justify-start gap-2 rounded-lg bg-primary-light-1 px-3 py-2 text-left focus:outline-none md:px-6 md:py-3">
            <div className="flex w-full items-center justify-start gap-2">
              <Typography
                variant="body1"
                component="span"
                color={value ? 'textPrimary' : 'textSecondary'}
                className="flex-1">
                {displayValue}
              </Typography>

              <HiChevronDown
                className="h-5 w-5 text-text-secondary"
                aria-hidden="true"
              />
            </div>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <Listbox.Options className="absolute z-100 mt-1 max-h-60 w-full min-w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {projects.map((project) => (
                <Listbox.Option
                  key={project.id}
                  className={({ active }) =>
                    cx(
                      `relative cursor-pointer select-none px-6 py-2`,
                      active && 'bg-primary-light-1',
                    )
                  }
                  value={project}>
                  {({ selected }) => (
                    <>
                      <Typography variant="body1" className="font-medium">
                        {project.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {project.description}
                      </Typography>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>

      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default ProjectSelector;
